<template>
  <div class="container-fluid transactions-page px-0 px-lg-3">
    <div class="row">
      <div class="col-12">
        <div class="transactions-board" :class="darkMode ? 'darkmode' : ''">
          <div
            ref="headerRef"
            class="row align-items-center sticky-top modern-header mx-0 d-none d-md-flex"
            :class="[darkMode ? 'darkmode' : '', { compact: isHeaderCompact }, { 'is-stuck': isHeaderStuck }]"
          >
            <div class="col-12 col-lg-4 order-2 order-lg-1 mt-3 mt-lg-0">
              <div class="header-summary-card hover-lift">
                <small>{{ t('message.transactions.current_balance') }}</small>
                <strong>{{ formatMoney(store.state.balance) }}</strong>
              </div>
            </div>

            <div class="col-12 col-lg-4 text-center order-1 order-lg-2 mt-2 mt-lg-0">
              <div class="month-switcher">
                <button class="month-nav" @click="slideDate('prev')" aria-label="Mês anterior">
                  <i class="fal fa-chevron-left"></i>
                </button>

                <transition name="month-fade" mode="out-in">
                  <div class="month-switcher-label hover-lift" :key="monthTitle">
                    <small>{{ t('message.global.transaction', store.state.transations.length) }}</small>
                    <span>{{ monthTitle }}</span>
                  </div>
                </transition>

                <button class="month-nav" @click="slideDate('next')" aria-label="Próximo mês">
                  <i class="fal fa-chevron-right"></i>
                </button>
              </div>
            </div>

            <div class="col-12 col-lg-4 order-3 mt-3 mt-lg-0">
              <div class="header-actions-wrap">
                <div class="header-summary-card projected-card text-start text-lg-end ms-lg-auto hover-lift">
                  <small>{{ t('message.transactions.future_balance') }}</small>
                  <strong :class="summaryProjectedClass">{{ formatMoney(store.state.foreseen) }}</strong>
                </div>

                <a
                  class="trasation-list-add-button text-white filter-floating-button"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#filterTransactions"
                  v-tooltip="{ content: t('message.transactions.filters'), distance: 13 }"
                >
                  <i class="fal fa-filter"></i>
                  <span class="filter-count" v-if="activeFiltersCount > 0">{{ activeFiltersCount }}</span>
                </a>
              </div>
            </div>
          </div>

          <div class="row sticky-top header-transaction mobile-header-wrap mx-0 d-md-none" :class="[
            darkMode ? 'darkmode' : '',
            { 'is-stuck': isHeaderStuck }
          ]">
                    <div class="col-12 text-center mb-2">
                        <div class="mobile-month-row">
                            <button class="mobile-month-nav" @click="slideDate('prev')" aria-label="Mês anterior">
                                <i class="fal fa-chevron-left"></i>
                            </button>

                            <div class="mobile-month-pill">
                                <small>{{ t('message.global.transaction', store.state.transations.length) }}</small>
                                <span>{{ store.state.selectedMonth.display }} {{ store.state.selectedYear }}</span>
                            </div>

                            <button class="mobile-month-nav" @click="slideDate('next')" aria-label="Próximo mês">
                                <i class="fal fa-chevron-right"></i>
                            </button>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="mobile-balance-row">
                            <div class="mobile-balance-card">
                                <small>{{ t('message.transactions.current_balance') }}</small>
                                <strong>{{ formatMoney(store.state.balance) }}</strong>
                            </div>

                            <div class="mobile-balance-card projected">
                                <small>{{ t('message.transactions.future_balance') }}</small>
                                <strong :class="parseFloat(store.state.foreseen) >= 0 ? 'text-success' : 'text-danger'">
                                    {{ formatMoney(store.state.foreseen) }}
                                </strong>
                            </div>

                            <a class="trasation-list-add-button text-white mobile-filter-btn" type="button" data-bs-toggle="modal" data-bs-target="#filterTransactions" v-tooltip="{
                                            content:'Filtrar',
                                            distance: 13
                                        }">
                                <i class="fal fa-filter"></i>
                                <span class="mobile-filter-count" v-if="isFiltered() > 0">{{ isFiltered() }}</span>
                            </a>
                        </div>
                    </div>
                </div>

          <div id="transactionList" class="transactions-list-area" :class="!darkMode ? 'bg-white' : 'bg-222222'">
            <div class="top-fade-shadow"></div>

            <div class="col-12 text-center mt-4 mb-4" v-if="store.state.loadingTransactions">
              <div class="row px-2 px-lg-3">
                <div class="col-12" v-for="n in 4" :key="n">
                  <div class="ultra-skeleton-card mb-3">
                    <div class="ultra-skeleton-icon"></div>
                    <div class="ultra-skeleton-content">
                      <div class="ultra-skeleton-line w-40"></div>
                      <div class="ultra-skeleton-line w-25 mt-2"></div>
                    </div>
                    <div class="ultra-skeleton-side">
                      <div class="ultra-skeleton-line w-20 ms-auto"></div>
                      <div class="ultra-skeleton-line w-30 mt-2 ms-auto"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 text-center mt-4 empty-transactions" v-if="store.state.transations.length == 0 && !store.state.loadingTransactions">
              <div class="empty-premium-state" :class="darkMode ? 'darkmode' : ''">
                <div class="empty-premium-icon">💸</div>
                <h4>{{ t('message.global.zero_transactions') }}</h4>
                <p>Nenhum lançamento encontrado para esse período.</p>
              </div>
            </div>

            <div class="modern-transaction-list" v-if="!store.state.loadingTransactions && store.state.transations.length > 0">
              <section v-for="group in groupedTransactions" :key="group.date" class="transaction-day-group">
                <div class="group-sticky-wrap">
                  <div
                    class="group-sticky-label"
                    :class="[
                      darkMode ? 'darkmode' : '',
                      group.isToday ? 'is-today' : '',
                      activeGroupDate === group.date ? 'is-active' : ''
                    ]"
                    :style="stickyStyle"
                  >
                    <div>
                      <strong>{{ group.label }}</strong>
                      <small>{{ group.items.length }} {{ group.items.length > 1 ? 'lançamentos' : 'lançamento' }}</small>
                    </div>
                    <span :class="group.total >= 0 ? 'text-success' : 'text-danger'">{{ formatMoney(group.total) }}</span>
                  </div>
                </div>

                <div class="group-cards">
                  <div
                    v-for="(transation, index) in group.items"
                    :key="`${group.date}-${transation.id || index}`"
                    class="premium-row-enter"
                    :style="{ animationDelay: `${index * 45}ms` }"
                  >
                    <TransactionsRow
                      :transaction="transation"
                      :darkmode="darkMode"
                      @edit="editTrasaction"
                      @pay="payTransation"
                    />
                  </div>
                </div>
              </section>
            </div>
          </div>

          
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="filterTransactions" tabindex="-1" aria-labelledby="filterTransactions" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-filter-transactions">
      <div class="modal-content filter-modal-content border-0" :class="{ 'darkmode': darkMode }">
        <div class="modal-body filter-modal-body" :class="darkMode ? 'darkmode' : ''">
          <div class="filter-modal-header">
            <div>
              <span class="filter-modal-kicker">{{ t('message.transactions.filters') }}</span>
              <h3 class="filter-modal-title">{{ t('message.transactions.filters') }}</h3>
              <p class="filter-modal-subtitle">Refine sua visualização para encontrar lançamentos mais rápido.</p>
            </div>

            <button
              type="button"
              class="filter-modal-close"
              data-bs-dismiss="modal"
              aria-label="Fechar"
            >
              <i class="fal fa-times"></i>
            </button>
          </div>

          <div class="filter-modal-card">
            <div class="row g-3">
              <div class="col-12">
                <label for="filterAccount" class="filter-label">{{ t('message.global.bank_account') }}</label>
                <select
                  v-if="store.state.accounts.length >= 1"
                  class="form-select form-select-lg filter-select"
                  aria-label="Conta"
                  v-model="store.state.filter.account"
                  id="filterAccount"
                  :class="{ 'darkmode': darkMode }"
                >
                  <option value="" selected disabled>{{ t('message.global.select_option') }}</option>
                  <option v-for="(account, index) in store.state.accounts" :key="index" :value="account.id">
                    {{ account.name }}
                  </option>
                </select>
              </div>

              <div class="col-12 col-md-6">
                <label for="filterStatus" class="filter-label">{{ t('message.transactions.status') }}</label>
                <select
                  v-if="store.state.accounts.length >= 1"
                  class="form-select form-select-lg filter-select"
                  aria-label="Status"
                  v-model="store.state.filter.status"
                  id="filterStatus"
                  :class="{ 'darkmode': darkMode }"
                >
                  <option value="" selected disabled>{{ t('message.global.select_option') }}</option>
                  <option value="Unpaid">{{ t('message.global.not_payed') }}</option>
                  <option value="Paid">{{ t('message.global.payed') }}</option>
                </select>
              </div>

              <div class="col-12 col-md-6">
                <label for="filterType" class="filter-label">{{ t('message.transactions.type') }}</label>
                <select
                  v-if="store.state.accounts.length >= 1"
                  class="form-select form-select-lg filter-select"
                  aria-label="Tipo"
                  v-model="store.state.filter.type"
                  id="filterType"
                  :class="{ 'darkmode': darkMode }"
                >
                  <option value="" selected disabled>{{ t('message.global.select_option') }}</option>
                  <option value="receita">{{ t('message.global.revenue') }}</option>
                  <option value="despesa">{{ t('message.global.expense') }}</option>
                  <option value="transferencia">{{ t('message.global.transfer') }}</option>
                </select>
              </div>

              <div class="col-12">
                <div class="filter-range-head">
                  <span class="filter-range-title">{{ t('message.transactions.period') }}</span>
                  <small class="filter-range-subtitle">Selecione um intervalo de dias para esse mês.</small>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <label for="filterStartDay" class="filter-label">{{ t('message.transactions.from') }}</label>
                <select
                  v-if="store.state.accounts.length >= 1"
                  class="form-select form-select-lg filter-select"
                  aria-label="Dia inicial"
                  v-model="store.state.filter.startDay"
                  id="filterStartDay"
                  :class="{ 'darkmode': darkMode }"
                >
                  <option v-for="n in 31" :key="n" :value="n < 10 ? '0' + n : n">
                    {{ n < 10 ? '0' + n : n }}
                  </option>
                </select>
              </div>

              <div class="col-12 col-md-6">
                <label for="filterEndDay" class="filter-label">{{ t('message.transactions.to') }}</label>
                <select
                  v-if="store.state.accounts.length >= 1"
                  class="form-select form-select-lg filter-select"
                  aria-label="Dia final"
                  v-model="store.state.filter.endDay"
                  id="filterEndDay"
                  :class="{ 'darkmode': darkMode }"
                >
                  <option v-for="n in 31" :key="n" :value="n < 10 ? '0' + n : n">
                    {{ n < 10 ? '0' + n : n }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="filter-modal-actions">
            <button class="filter-clear-button" data-bs-dismiss="modal" @click="clearFilter()" type="button">
              <i class="fal fa-eraser"></i>
              <span>{{ t('message.transactions.clean_filters') }}</span>
            </button>

            <button class="filter-apply-button" @click="getTransaction(false)" data-bs-dismiss="modal" type="button">
              <i class="fal fa-check"></i>
              <span>{{ t('message.transactions.apply') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onBeforeMount, onMounted, onUnmounted, onUpdated, computed, ref, nextTick } from "vue";
import TransactionsRow from "../components/TransactionsRow.vue";
import setTooltip from "../assets/js/tooltip";
import validSession from "../assets/js/valid-session.js";
import { useStore } from "vuex";
import axios from "axios";
import bootstrap from "bootstrap/dist/js/bootstrap";
import { toast } from 'vue3-toastify';
import 'animate.css';
import { useRoute } from "vue-router";
import SkeletonLoad from "../components/SkeletonLoad.vue";
import emitter from "../assets/js/eventBus.js";
import startResize from "../assets/js/resize.js";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const meses = [
  t('message.global.month.jan'),
  t('message.global.month.feb'),
  t('message.global.month.mar'),
  t('message.global.month.apr'),
  t('message.global.month.may'),
  t('message.global.month.jun'),
  t('message.global.month.jul'),
  t('message.global.month.aug'),
  t('message.global.month.sep'),
  t('message.global.month.oct'),
  t('message.global.month.nov'),
  t('message.global.month.dec')
];

const store = useStore();
const route = useRoute();
const headerRef = ref(null);
const stickyOffset = ref(136);
const isHeaderCompact = ref(false);
const activeGroupDate = ref('');
const isHeaderStuck = ref(false);

const darkMode = computed(() => store.state.darkMode);
const monthTitle = computed(() => `${store.state.selectedMonth.display} ${store.state.selectedYear}`);
const summaryProjectedClass = computed(() => parseFloat(store.state.foreseen) >= 0 ? 'text-success' : 'text-danger');
const stickyStyle = computed(() => ({ top: `${stickyOffset.value + 10}px` }));

const activeFiltersCount = computed(() => {
  let filtered = 0;
  if (store.state.filter.account !== '') filtered += 1;
  if (store.state.filter.status !== '') filtered += 1;
  if (store.state.filter.type !== '') filtered += 1;
  if (store.state.filter.startDay !== '') filtered += 1;
  if (store.state.filter.endDay !== '') filtered += 1;
  return filtered;
});

const groupedTransactions = computed(() => {
  const items = Array.isArray(store.state.transations) ? store.state.transations : [];
  const groups = {};
  const todayKey = new Date().toISOString().slice(0, 10);

  items.forEach((transaction) => {
    const rawDate = transaction?.date || store.state.current_date;
    if (!groups[rawDate]) groups[rawDate] = [];
    groups[rawDate].push(transaction);
  });

  return Object.keys(groups)
    .sort((a, b) => new Date(a) - new Date(b))
    .map((date) => {
      const items = groups[date];
      const total = items.reduce((acc, item) => {
        const amount = parseFloat(item.amount || 0);
        if (item.type === 'despesa') return acc - amount;
        return acc + amount;
      }, 0);

      return {
        date,
        label: formatGroupDate(date),
        total,
        items,
        isToday: date === todayKey,
      };
    });
});

const updateStickyMetrics = () => {
  nextTick(() => {
    if (headerRef.value) {
      stickyOffset.value = Math.ceil(headerRef.value.getBoundingClientRect().height);
    }
  });
};

const updateScrollEffects = () => {
  const y = window.scrollY || window.pageYOffset;
  isHeaderCompact.value = y > 26;
  isHeaderStuck.value = y > 26;

  const labels = document.querySelectorAll('.transaction-day-group');
  let currentActive = '';

  labels.forEach((group) => {
    const rect = group.getBoundingClientRect();
    if (rect.top <= stickyOffset.value + 30) {
      currentActive = group.getAttribute('data-group-date') || currentActive;
    }
  });

  activeGroupDate.value = currentActive;
};

onBeforeMount(() => {
  validSession.isLogged();

  store.state.transaction_value = { value: 0 };
  store.state.accounts = [];
  store.state.cards = [];
  store.state.transations = [];
  store.state.categoriesExpense = {};
  store.state.categoriesRevenue = {};
  store.state.savingTransaction = false;
  store.state.modalColor = '';
  store.state.objetives = [];
  store.state.suggestions = [];

  store.state.selectedYear = new Date().getFullYear();
  store.state.selectedMonth = {
    index: new Date().getMonth(),
    number: new Date().getMonth() + 1,
    display: meses[new Date().getMonth()]
  };

  store.state.validation = {
    descHasError: false,
    descMessageError: '',
  };

  const day = new Date().getDate();
  const month = new Date().getMonth() + 1;
  const year = new Date().getFullYear();

  store.state.current_date = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);

  store.state.transation = {
    type: '',
    description: '',
    amount: 0,
    date: store.state.current_date,
    account: '',
    account_name: '',
    account_destiny: '',
    account_destiny_name: '',
    category: '',
    category_name: '',
    category_icon: '',
    category_color: '',
    recurrence_checked: false,
    recurrence: '',
    recurrence_period: 'monthly',
    initial_installment: 1,
    current_installment: 1,
    end_installment: 1,
    payed: false,
    id: '',
    transaction_id: '',
    invoice_id: '',
    card_id: '',
    howUpdate: '',
    amount_paid: 0,
    ammount_unpaid: 0,
    observation: '',
    objetive_checked: false,
    objetive: '',
    customer_supplier: ''
  };

  store.state.balance = 0;
  store.state.loading_balance = true;
  store.state.foreseen_revenue = 0;
  store.state.revenue_done = 0;
  store.state.foreseen = 0;
  store.state.foreseen_expense = 0;
  store.state.expense_done = 0;

  store.state.invoice_id = route.params.id;

  store.state.filter = {
    account: '',
    status: '',
    type: '',
    startDay: route.query.day ? route.query.day : '',
    endDay: route.query.day ? route.query.day : ''
  };

  store.state.filtered = 0;
  store.state.loadingTransactions = true;
  getTransaction(false);
  getCards();
  getAccounts();
  getExpenseCategories();
  getRevenueCategories();
  getObjetives();
});

const reload_data = (res) => {
  getTransaction(res.editing, res.transaction_id);
};

onMounted(() => {
  emitter.on('load-data', reload_data);
  setTooltip();
  updateStickyMetrics();
  updateScrollEffects();
  window.addEventListener('scroll', updateScrollEffects, { passive: true });
  window.addEventListener('resize', updateStickyMetrics, { passive: true });
});

onUpdated(() => {
  if (!store.state.loadingTransactions) {
    startResize();
  }
  updateStickyMetrics();
  nextTick(() => {
    document.querySelectorAll('.transaction-day-group').forEach((group) => {
      if (!group.getAttribute('data-group-date')) {
        const key = group.querySelector('.group-sticky-label strong')?.textContent || '';
        group.setAttribute('data-group-date', key);
      }
    });
    updateScrollEffects();
  });
});

onUnmounted(() => {
  emitter.off('load-data', reload_data);
  window.removeEventListener('scroll', updateScrollEffects);
  window.removeEventListener('resize', updateStickyMetrics);
});

const getTransaction = async () => {
  const period = store.state.selectedYear + '-' + (store.state.selectedMonth.number < 10 ? '0' + store.state.selectedMonth.number : store.state.selectedMonth.number);
  const account = store.state.filter.account;
  const status = store.state.filter.status;
  const type = store.state.filter.type;
  const dayStart = store.state.filter.startDay;
  const dayEnd = store.state.filter.endDay;

  axios.get('transactions?period=' + period + '&account=' + account + '&status=' + status + '&type=' + type + '&dayStart=' + dayStart + '&dayEnd=' + dayEnd)
    .then(res => {
      if (res.status == 200) {
        store.state.transations = res.data;
        store.state.loadingTransactions = false;
        getBalance();
        nextTick(() => {
          updateStickyMetrics();
          updateScrollEffects();
        });
      }
    })
    .catch(err => {
      console.error(err);
    });
};

const getAccounts = async () => {
  axios.get('accounts?archived=No')
    .then(res => {
      if (res.status == 200) {
        store.state.accounts = res.data;
      }
    })
    .catch(err => {
      console.error(err);
    });
};

const getCards = async () => {
  axios.get('credit-cards')
    .then(res => {
      if (res.status == 200) {
        store.state.cards = res.data;
      }
    })
    .catch(err => {
      console.error(err);
    });
};

const getExpenseCategories = async () => {
  axios.get('categories?type=despesa')
    .then(res => {
      if (res.status == 200) {
        store.state.categoriesExpense = res.data;
      }
    })
    .catch(err => {
      console.error(err);
    });
};

const getRevenueCategories = async () => {
  axios.get('categories?type=receita')
    .then(res => {
      if (res.status == 200) {
        store.state.categoriesRevenue = res.data;
      }
    })
    .catch(err => {
      console.error(err);
    });
};

const getBalance = async () => {
  axios.get('accounts/balance')
    .then(res => {
      if (res.status == 200) {
        store.state.balance = res.data[0].balance;
        store.state.foreseen_revenue = 0;
        store.state.revenue_done = 0;
        store.state.foreseen = 0;
        store.state.foreseen_expense = 0;
        store.state.expense_done = 0;

        calc_balance();
        store.state.loading_balance = false;
      }
    })
    .catch(err => {
      console.error(err);
    });
};

const clearFields = () => {
  store.state.transaction_value.value = 0;

  store.state.transation = {
    type: '',
    description: '',
    amount: 0,
    date: store.state.current_date,
    account: '',
    account_name: '',
    account_destiny: '',
    account_destiny_name: '',
    category: '',
    category_name: '',
    category_icon: '',
    category_color: '',
    recurrence_checked: false,
    recurrence: '',
    recurrence_period: 'monthly',
    initial_installment: 1,
    current_installment: 1,
    end_installment: 1,
    payed: false,
    id: '',
    transaction_id: '',
    invoice_id: '',
    card_id: '',
    howUpdate: '',
    amount_paid: 0,
    ammount_unpaid: 0,
    observation: '',
    objetive: '',
    customer_supplier: ''
  };

  store.state.suggestions = [];
};

const editTrasaction = (data) => {
  emitter.emit('edit-transaction', { data });
  emitter.emit('set-type', { data: data.type });
};

const payTransation = (transaction) => {
  if (transaction.type != 'transferência' && transaction.status == 'Unpaid') {
    emitter.emit('set-type', { data: transaction.type });

    store.state.transaction_value.value = formatMoney(transaction.amount);

    store.state.transation = {
      type: transaction.type,
      description: transaction.description,
      amount: formatMoney(transaction.amount),
      date: transaction.date,
      account: transaction.account_id > 0 ? transaction.account_id + '-bank' : transaction.card_id + '-card',
      account_name: transaction.account_name,
      account_destiny: transaction.account_destiny_id > 0 ? transaction.account_destiny_id + '-bank' : '',
      account_destiny_name: transaction.account_destiny_name,
      category: transaction.category_id,
      category_name: transaction.category_name,
      category_icon: transaction.category_icon,
      category_color: transaction.category_color,
      recurrence_checked: false,
      recurrence: transaction.recurrence,
      recurrence_period: '',
      initial_installment: 1,
      current_installment: transaction.current_installment,
      end_installment: transaction.end_installment,
      payed: 'Paid',
      id: transaction.id,
      transaction_id: transaction.transaction_id,
      invoice_id: transaction.invoice_id,
      card_id: transaction.card_id,
      howUpdate: 'just_this',
      amount_paid: transaction.amount_paid,
      ammount_unpaid: transaction.ammount_unpaid,
      observation: transaction.observation,
      customer_supplier: transaction.customer_suplier_id
    };

    openModal('payTransaction');
  } else {
    const url = '/transactions/pay/' + transaction.id;
    const data = new FormData();

    data.append('status', transaction.status == 'Paid' ? 'Unpaid' : 'Paid');

    axios.post(url, data)
      .then(res => {
        if (!res.data.error) {
          toast('Transação atualizada com sucesso!', {
            autoClose: 1000,
            theme: 'auto',
            type: 'success',
            transition: 'slide'
          });

          getTransaction(true, transaction.id);
          clearFields();
        }
      })
      .catch(err => {
        console.error(err);
      });
  }
};

const openModal = (id) => {
  const modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));
  modal.show();
};

const slideDate = (direction) => {
  if (direction == 'prev') {
    const prev_month = store.state.selectedMonth.index > 0 ? store.state.selectedMonth.index - 1 : 11;
    const prev_year = store.state.selectedMonth.index > 0 ? store.state.selectedYear : store.state.selectedYear - 1;

    store.state.selectedYear = prev_year;
    store.state.selectedMonth = {
      index: prev_month,
      number: prev_month + 1,
      display: meses[prev_month]
    };

    getTransaction();
  } else if (direction == 'next') {
    const next_month = store.state.selectedMonth.index < 11 ? store.state.selectedMonth.index + 1 : 0;
    const next_year = store.state.selectedMonth.index < 11 ? store.state.selectedYear : store.state.selectedYear + 1;

    store.state.selectedYear = next_year;
    store.state.selectedMonth = {
      index: next_month,
      number: next_month + 1,
      display: meses[next_month]
    };

    getTransaction();
  }
};

const formatMoney = (v) => {
  const total = parseFloat(v || 0);
  return total.toLocaleString(t('message.global.date_language'), {
    style: 'currency',
    currency: 'BRL',
  });
};

const formatGroupDate = (date) => {
  const parsed = new Date(`${date}T00:00:00`);
  return parsed.toLocaleDateString(t('message.global.date_language'), {
    day: '2-digit',
    month: 'long',
    weekday: 'long',
  });
};

const rotate = (id) => {
  const element = document.getElementById(id);
  element.classList.toggle('fa-rotate-90');
};

const calc_balance = () => {
  store.state.transations.forEach((transaction) => {
    if (transaction.type == 'despesa') {
      if (transaction.status == 'Unpaid') {
        store.state.foreseen_expense += parseFloat(transaction.amount);
      } else if (transaction.status == 'Paid') {
        store.state.expense_done += parseFloat(transaction.amount);
      }
    } else if (transaction.type == 'receita') {
      if (transaction.status == 'Unpaid') {
        store.state.foreseen_revenue += parseFloat(transaction.amount);
      } else if (transaction.status == 'Paid') {
        store.state.revenue_done += parseFloat(transaction.amount);
      }
    }
  });

  store.state.foreseen = (parseFloat(store.state.balance) + parseFloat(store.state.foreseen_revenue)) - parseFloat(store.state.foreseen_expense);
};

const clearFilter = () => {
  store.state.filter = {
    account: '',
    status: '',
    type: '',
    startDay: '',
    endDay: ''
  };

  getTransaction(false);
};

const getObjetives = async () => {
  axios.get('objetives')
    .then(res => {
      if (res.status == 200) {
        store.state.objetives = res.data;
      }
    })
    .catch(err => {
      console.error(err);
    });
};

const isFiltered = () => {

    let filtered = 0;

    if(store.state.filter.account !== ''){

        filtered += 1;

    }

    if(store.state.filter.status !== ''){

        filtered += 1;

    }

    if(store.state.filter.type !== ''){

        filtered += 1;

    }

    if(store.state.filter.startDay !== ''){

        filtered += 1;

    }

    if(store.state.filter.endDay !== ''){

        filtered += 1;

    }

    return filtered;

}
</script>

<style scoped>
.transactions-page {
  --surface: #ffffff;
  --surface-soft: #f8f6f1;
  --border-soft: rgba(32, 59, 97, 0.08);
  --primary: #1f4776;
  --primary-soft: rgba(31, 71, 118, 0.1);
  --text-soft: #6c7d96;
}


.filter-modal-content {
  border-radius: 28px;
  overflow: hidden;
  background: linear-gradient(180deg, #ffffff 0%, #fbfaf7 100%);
  box-shadow: 0 24px 70px rgba(17, 36, 63, 0.22);
}

.filter-modal-body {
  padding: 26px;
  background:
    radial-gradient(circle at top right, rgba(241, 235, 222, 0.85), transparent 34%),
    linear-gradient(180deg, rgba(255,255,255,0.96), rgba(251,250,247,0.98));
}

.filter-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
}

.filter-modal-kicker {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(33, 62, 96, 0.08);
  color: #213e60;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .04em;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.filter-modal-title {
  margin: 0;
  color: #213e60;
  font-size: 28px;
  line-height: 1.1;
  font-weight: 800;
}

.filter-modal-subtitle {
  margin: 8px 0 0;
  color: #7a8797;
  font-size: 14px;
}

.filter-modal-close {
  width: 46px;
  height: 46px;
  flex: 0 0 46px;
  border: 1px solid rgba(33, 62, 96, 0.12);
  border-radius: 16px;
  background: rgba(255,255,255,0.86);
  color: #6d7c8e;
  box-shadow: 0 10px 24px rgba(17, 36, 63, 0.08);
  transition: all .2s ease;
}

.filter-modal-close:hover {
  transform: translateY(-1px);
  color: #213e60;
  border-color: rgba(213, 138, 55, 0.24);
}

.filter-modal-card {
  padding: 18px;
  border-radius: 24px;
  background: rgba(255,255,255,0.72);
  border: 1px solid rgba(33, 62, 96, 0.08);
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.6);
}

.filter-label {
  display: inline-block;
  margin-bottom: 8px;
  color: #3d5574;
  font-size: 14px;
  font-weight: 700;
}

.filter-select {
  min-height: 56px;
  border-radius: 16px;
  border: 1px solid #d7dee8;
  background-color: #ffffff;
  color: #314860;
  box-shadow: none !important;
  padding-left: 16px;
  padding-right: 44px;
  transition: all .2s ease;
}

.filter-select:hover {
  border-color: #c5cfdb;
}

.filter-select:focus {
  border-color: #d58a37;
  box-shadow: 0 0 0 4px rgba(213, 138, 55, 0.14) !important;
}

.filter-range-head {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: 4px;
}

.filter-range-title {
  color: #213e60;
  font-size: 15px;
  font-weight: 800;
}

.filter-range-subtitle {
  color: #8793a2;
  font-size: 12px;
}

.filter-modal-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
}

.filter-clear-button,
.filter-apply-button {
  min-height: 52px;
  border: 0;
  border-radius: 16px;
  padding: 0 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-weight: 700;
  transition: all .2s ease;
}

.filter-clear-button {
  background: rgba(33, 62, 96, 0.08);
  color: #3f5875;
}

.filter-clear-button:hover {
  background: rgba(33, 62, 96, 0.12);
  transform: translateY(-1px);
}

.filter-apply-button {
  background: linear-gradient(180deg, #de933d 0%, #d38834 100%);
  color: #ffffff;
  box-shadow: 0 14px 30px rgba(211, 136, 52, 0.26);
}

.filter-apply-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 18px 34px rgba(211, 136, 52, 0.3);
}

.filter-modal-content.darkmode {
  background: linear-gradient(180deg, #1f1f1f 0%, #191919 100%);
}

.filter-modal-body.darkmode {
  background:
    radial-gradient(circle at top right, rgba(213, 138, 55, 0.1), transparent 34%),
    linear-gradient(180deg, rgba(28,28,28,0.98), rgba(20,20,20,0.98));
}

.filter-modal-content.darkmode .filter-modal-kicker,
.filter-modal-body.darkmode .filter-modal-kicker {
  background: rgba(213, 138, 55, 0.14);
  color: #f0b066;
}

.filter-modal-content.darkmode .filter-modal-title,
.filter-modal-body.darkmode .filter-modal-title,
.filter-modal-content.darkmode .filter-range-title,
.filter-modal-body.darkmode .filter-range-title,
.filter-modal-content.darkmode .filter-label,
.filter-modal-body.darkmode .filter-label {
  color: #f5f7fb;
}

.filter-modal-content.darkmode .filter-modal-subtitle,
.filter-modal-body.darkmode .filter-modal-subtitle,
.filter-modal-content.darkmode .filter-range-subtitle,
.filter-modal-body.darkmode .filter-range-subtitle {
  color: rgba(255,255,255,0.62);
}

.filter-modal-content.darkmode .filter-modal-card,
.filter-modal-body.darkmode .filter-modal-card {
  background: rgba(255,255,255,0.03);
  border-color: rgba(255,255,255,0.06);
}

.filter-modal-content.darkmode .filter-modal-close,
.filter-modal-body.darkmode .filter-modal-close {
  background: rgba(255,255,255,0.04);
  border-color: rgba(255,255,255,0.06);
  color: rgba(255,255,255,0.7);
  box-shadow: none;
}

.filter-modal-content.darkmode .filter-select,
.filter-modal-body.darkmode .filter-select,
.filter-select.darkmode {
  background-color: #222222;
  border-color: rgba(255,255,255,0.08);
  color: #f5f7fb;
}

.filter-modal-content.darkmode .filter-clear-button,
.filter-modal-body.darkmode .filter-clear-button {
  background: rgba(255,255,255,0.06);
  color: #f5f7fb;
}

@media (max-width: 767.98px) {
  .modal-filter-transactions {
    margin: 0;
    padding: 12px;
  }

  .modal-filter-transactions .modal-dialog {
    margin: 0;
    max-width: 100%;
  }

  .filter-modal-content {
    border-radius: 24px;
    min-height: calc(100vh - 24px);
  }

  .filter-modal-body {
    padding: 18px 16px 16px;
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 24px);
  }

  .filter-modal-header {
    align-items: flex-start;
    margin-bottom: 14px;
  }

  .filter-modal-kicker {
    font-size: 11px;
    padding: 6px 10px;
    margin-bottom: 8px;
  }

  .filter-modal-title {
    font-size: 18px;
    line-height: 1.15;
  }

  .filter-modal-subtitle {
    font-size: 13px;
    line-height: 1.45;
    margin-top: 6px;
    max-width: 260px;
  }

  .filter-modal-close {
    width: 40px;
    height: 40px;
    flex: 0 0 40px;
    border-radius: 14px;
  }

  .filter-modal-card {
    padding: 14px;
    border-radius: 20px;
  }

  .filter-label {
    font-size: 13px;
    margin-bottom: 6px;
  }

  .filter-range-title {
    font-size: 14px;
  }

  .filter-range-subtitle {
    font-size: 11px;
    line-height: 1.4;
  }

  .filter-select {
    min-height: 50px;
    height: 50px;
    border-radius: 14px;
    font-size: 14px;
    padding-left: 14px;
    padding-right: 40px;
    background-position: right 14px center;
    background-size: 14px 10px;
  }

  .filter-modal-actions {
    margin-top: auto;
    padding-top: 16px;
    position: sticky;
    bottom: 0;
    background: linear-gradient(180deg, rgba(251,250,247,0) 0%, rgba(251,250,247,0.92) 20%, rgba(251,250,247,1) 100%);
    flex-direction: column-reverse;
    align-items: stretch;
    gap: 10px;
  }

  .filter-clear-button,
  .filter-apply-button {
    width: 100%;
    min-height: 50px;
    border-radius: 14px;
    font-size: 15px;
  }

  .filter-modal-body.darkmode .filter-modal-actions,
  .filter-modal-content.darkmode .filter-modal-actions {
    background: linear-gradient(180deg, rgba(20,20,20,0) 0%, rgba(20,20,20,0.9) 20%, rgba(20,20,20,1) 100%);
  }
}

.transactions-board {
  border-radius: 24px;
  overflow: visible;
  background: rgba(255,255,255,0.72);
  backdrop-filter: blur(10px);
  box-shadow: 0 18px 48px rgba(16, 34, 61, 0.08);
}

.modern-header {
  top: 0;
  z-index: 40;
  padding: 18px 10px;
  background: linear-gradient(135deg, #1d426d 0%, #274f84 100%);
  color: #fff;
  box-shadow: 0 12px 28px rgba(15, 33, 59, 0.12);
  transition: padding .22s ease, box-shadow .22s ease, backdrop-filter .22s ease, background .22s ease;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  transition: all 0.25s ease;
}

.modern-header.is-stuck { 
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  box-shadow: 0 8px 20px rgba(0,0,0,0.15); 
}

.modern-header.compact {
  padding: 10px 10px;
  backdrop-filter: blur(14px);
  background: linear-gradient(135deg, rgba(29, 66, 109, 0.94) 0%, rgba(39, 79, 132, 0.94) 100%);
  box-shadow: 0 16px 36px rgba(15, 33, 59, 0.18);
}

.header-summary-card {
  padding: 12px 16px;
  border-radius: 18px;
  background: rgba(255,255,255,0.12);
  backdrop-filter: blur(8px);
}

.hover-lift {
  transition: transform .22s ease, background-color .22s ease, box-shadow .22s ease;
}

.hover-lift:hover {
  transform: translateY(-1px);
  background: rgba(255,255,255,0.16);
}

.header-summary-card small {
  display: block;
  font-size: 12px;
  opacity: .85;
  margin-bottom: 4px;
}

.header-summary-card strong {
  font-size: 22px;
  line-height: 1.1;
}

.header-actions-wrap {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.projected-card {
  min-width: 210px;
}

.month-switcher {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.month-switcher-label {
  min-width: 220px;
  padding: 10px 18px;
  border-radius: 18px;
  background: rgba(255,255,255,0.12);
}

.month-switcher-label small {
  display: block;
  opacity: .8;
  font-size: 12px;
}

.month-switcher-label span {
  display: block;
  font-size: 24px;
  font-weight: 700;
  text-transform: capitalize;
}

.month-nav {
  width: 42px;
  height: 42px;
  border: none;
  border-radius: 14px;
  background: rgba(255,255,255,0.14);
  color: #fff;
  transition: .2s ease;
}

.month-nav:hover,
.filter-floating-button:hover {
  transform: translateY(-1px) scale(1.02);
}

.filter-floating-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 16px;
  background: rgba(255,255,255,0.14);
  box-shadow: 0 10px 22px rgba(8, 21, 41, 0.18);
  transition: .2s ease;
}

.filter-count {
  position: absolute;
  top: -5px;
  right: -4px;
  min-width: 19px;
  height: 19px;
  padding: 0 5px;
  border-radius: 999px;
  background: #f59b39;
  color: #fff;
  font-size: 11px;
  line-height: 19px;
  text-align: center;
  box-shadow: 0 6px 12px rgba(245, 155, 57, 0.35);
}

.transactions-list-area {
  position: relative;
  padding: 20px 12px 10px;
  min-height: 420px;
  scroll-behavior: smooth;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
}

.top-fade-shadow {
  position: sticky;
  top: 0;
  z-index: 15;
  height: 14px;
  margin: -20px -12px 10px;
  background: linear-gradient(to bottom, rgba(17, 35, 60, 0.08), rgba(17, 35, 60, 0));
  pointer-events: none;
}

.modern-transaction-list {
  padding: 4px 0 12px;
}

.transaction-day-group {
  position: relative;
}

.transaction-day-group + .transaction-day-group {
  margin-top: 18px;
}

.group-sticky-wrap {
  position: relative;
  z-index: 18;
}

.group-sticky-label {
  position: sticky;
  z-index: 18;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  margin-bottom: 12px;
  border-radius: 18px;
  background: rgba(245, 241, 231, 0.92);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  color: var(--primary);
  border: 1px solid rgba(32, 59, 97, 0.08);
  box-shadow: 0 10px 24px rgba(16, 34, 61, 0.06);
  transform: none;
  transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease, background-color .18s ease;
}

.group-sticky-label::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: linear-gradient(180deg, rgba(255,255,255,0.22), rgba(255,255,255,0));
  pointer-events: none;
}

.group-sticky-label.darkmode {
  background: rgba(34, 34, 34, 0.9);
  border-color: rgba(255,255,255,0.06);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.22);
}

.group-sticky-label.is-active {
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(16, 34, 61, 0.1);
}

.group-sticky-label.is-today {
  border-color: rgba(72, 196, 125, 0.38);
}

.group-sticky-label strong,
.group-sticky-label small,
.group-sticky-label span {
  position: relative;
  z-index: 1;
}

.group-sticky-label strong,
.group-sticky-label small {
  display: block;
}

.group-sticky-label strong {
  font-size: 18px;
  line-height: 1.1;
  text-transform: capitalize;
}

.group-sticky-label small {
  color: var(--text-soft);
  font-size: 12px;
  text-transform: capitalize;
  margin-top: 4px;
}

.group-cards {
  display: grid;
  gap: 10px;
}

.group-cards :deep(.transaction-modern-card) {
  border-radius: 18px;
}

.premium-row-enter {
  opacity: 0;
  transform: translateY(10px);
  animation: premiumRowIn .3s ease forwards;
}

.empty-transactions {
  padding: 70px 20px;
  color: var(--text-soft);
}

.empty-premium-state {
  padding: 38px 20px;
  border-radius: 24px;
  background: linear-gradient(180deg, rgba(245, 241, 231, 0.85), rgba(255,255,255,0.92));
  border: 1px solid rgba(32, 59, 97, 0.08);
}

.empty-premium-state.darkmode {
  background: linear-gradient(180deg, rgba(255,255,255,0.04), rgba(255,255,255,0.02));
  border-color: rgba(255,255,255,0.06);
}

.empty-premium-icon {
  font-size: 42px;
  margin-bottom: 8px;
}

.ultra-skeleton-card {
  display: grid;
  grid-template-columns: 56px 1fr 180px;
  gap: 16px;
  align-items: center;
  padding: 16px 18px;
  border-radius: 20px;
  background: rgba(255,255,255,0.78);
  border: 1px solid rgba(32, 59, 97, 0.08);
}

.ultra-skeleton-icon,
.ultra-skeleton-line {
  position: relative;
  overflow: hidden;
  background: #e9edf3;
}

.ultra-skeleton-icon::after,
.ultra-skeleton-line::after {
  content: '';
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent);
  animation: shimmer 1.35s infinite;
}

.ultra-skeleton-icon {
  width: 56px;
  height: 56px;
  border-radius: 18px;
}

.ultra-skeleton-content,
.ultra-skeleton-side {
  width: 100%;
}

.ultra-skeleton-line {
  height: 14px;
  border-radius: 999px;
}

.w-40 { width: 40%; }
.w-30 { width: 30%; }
.w-25 { width: 25%; }
.w-20 { width: 20%; }

.modern-footer {
  padding: 0 10px 14px;
  background: transparent;
}

.ultra-footer-card {
  box-shadow: 0 12px 26px rgba(16, 34, 61, 0.05);
}

.footer-balance-card {
  padding: 16px 10px 14px;
  border-radius: 22px;
  background: var(--surface-soft);
  border: 1px solid var(--border-soft);
}

.footer-expand {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 12px;
  background: rgba(31, 71, 118, 0.08);
  color: var(--primary);
}

.darkmode .footer-balance-card {
  background: rgba(255,255,255,0.03);
  border-color: rgba(255,255,255,0.06);
}

.darkmode .group-sticky-label small {
  color: rgba(255,255,255,0.65);
}

.month-fade-enter-active,
.month-fade-leave-active {
  transition: all .18s ease;
}

.month-fade-enter-from,
.month-fade-leave-to {
  opacity: 0;
  transform: translateY(4px);
}

@keyframes premiumRowIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}

@media (max-width: 991.98px) {
  .modern-header {
    padding: 16px 6px;
  }

  .header-actions-wrap {
    justify-content: space-between;
  }

  .projected-card,
  .month-switcher-label {
    min-width: initial;
    width: 100%;
  }

  .month-switcher {
    width: 100%;
  }

  .ultra-skeleton-card {
    grid-template-columns: 56px 1fr;
  }

  .ultra-skeleton-side {
    display: none;
  }
}

@media (max-width: 767.98px) {
  .modern-header {
    padding: 12px 8px;
  }

  .modern-header .col-12 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .month-switcher {
    width: 100%;
    gap: 8px;
    margin-bottom: 10px;
  }

  .month-switcher-label {
    min-width: 0;
    width: 100%;
    padding: 8px 12px;
    border-radius: 16px;
  }

  .month-switcher-label small {
    font-size: 11px;
  }

  .month-switcher-label span {
    font-size: 15px;
    line-height: 1.2;
  }

  .month-nav {
    width: 38px;
    height: 38px;
    border-radius: 12px;
    flex-shrink: 0;
  }

  .header-summary-card {
    padding: 10px 12px;
    border-radius: 16px;
  }

  .header-summary-card small {
    font-size: 10px;
    margin-bottom: 2px;
  }

  .header-summary-card strong {
    font-size: 16px;
  }

  .header-actions-wrap {
    display: grid;
    grid-template-columns: 1fr 1fr auto;
    gap: 8px;
    align-items: center;
    margin-top: 6px;
  }

  .projected-card {
    min-width: 0;
    width: 100%;
  }

  .filter-floating-button {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    margin-left: auto;
  }

  .filter-floating-button i {
    font-size: 14px;
  }

  .filter-count {
    top: -4px;
    right: -4px;
    min-width: 17px;
    height: 17px;
    line-height: 17px;
    font-size: 10px;
  }

  .transactions-list-area {
    padding: 12px 8px 8px;
    margin-bottom: 120px;
    border-bottom-left-radius: 24px;
    border-bottom-right-radius: 24px;
  }

  .group-sticky-label {
    padding: 9px 12px;
    border-radius: 14px;
  }

  .group-sticky-label strong {
    font-size: 15px;
  }

  .group-sticky-label small {
    font-size: 11px;
  }
}

.mobile-header-wrap{
    top: 0;
    z-index: 40;
    padding: 18px 10px;
    background: linear-gradient(135deg, #1d426d 0%, #274f84 100%);
    color: #fff;
    box-shadow: 0 12px 28px rgba(15, 33, 59, 0.12);
    transition: padding .22s ease, box-shadow .22s ease, backdrop-filter .22s ease, background .22s ease;
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
    transition: all 0.25s ease;
}

.mobile-header-wrap.is-stuck { 
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  box-shadow: 0 8px 20px rgba(0,0,0,0.15); 
}

.mobile-month-row{
    display:grid;
    grid-template-columns:38px 1fr 38px;
    gap:8px;
    align-items:center;
}
.mobile-month-nav{
    width:38px;
    height:38px;
    border:none;
    border-radius:12px;
    background:rgba(255,255,255,0.14);
    color:#fff;
}
.mobile-month-pill{
    min-width:0;
    padding:8px 12px;
    border-radius:14px;
    background:rgba(255,255,255,0.12);
    text-align:center;
}
.mobile-month-pill small{
    display:block;
    font-size:11px;
    opacity:.85;
    line-height:1.1;
}
.mobile-month-pill span{
    display:block;
    font-size:16px;
    font-weight:700;
    line-height:1.2;
    text-transform:capitalize;
}
.mobile-balance-row{
    display:grid;
    grid-template-columns:minmax(0,1fr) minmax(0,1fr) 40px;
    gap:8px;
    align-items:stretch;
}
.mobile-balance-card{
    min-width:0;
    padding:9px 10px;
    border-radius:14px;
    background:rgba(255,255,255,0.12);
}
.mobile-balance-card small{
    display:block;
    font-size:10px;
    opacity:.85;
    margin-bottom:2px;
}
.mobile-balance-card strong{
    display:block;
    font-size:13px;
    line-height:1.15;
}
.mobile-filter-btn{
    position:relative;
    width:40px;
    height:40px;
    border-radius:12px;
    display:inline-flex;
    align-items:center;
    justify-content:center;
    background:rgba(255,255,255,0.14);
    align-self:center;
    justify-self:end;
}
.mobile-filter-count{
    position:absolute;
    top:-4px;
    right:-4px;
    min-width:17px;
    height:17px;
    border-radius:999px;
    background:#f59b39;
    color:#fff;
    font-size:10px;
    line-height:17px;
    text-align:center;
    padding:0 4px;
}
@media (min-width: 992px){
    .mobile-header-wrap{
        padding: 16px 10px;
    }
    .mobile-month-pill span{
        font-size:18px;
    }
    .mobile-balance-card strong{
        font-size:14px;
    }
    #transactionList{
      margin-bottom: 150px !important;
    }
}
</style>
